import styled from "styled-components";
import PrimaryButton from "../../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../../components/FormControls/SecondaryButton";
import FormSelectWithLabel from "../../../../../components/FormControls/FormSelectWithLabel";
import FormDatePicker from "../../../../../components/FormControls/FormDatePicker";
import FormCheckBoxWithRightLabel from "../../../../../components/FormControls/FormCheckBoxWithRightLabel"
import { useState, useEffect } from "react";
import React from "react";
import request from "../../../../../api/request";
import NotificationManager from "react-notifications/lib/NotificationManager";

const FadeBackground = styled.div`
    display: flex;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10000;
    left: 0;
    top: 0;
    background-color: #32323233;
`;

const StyledOverDueYearEndFiling = styled.div`
    display: flex;
    flex-direction: column;
    background-color: white;
    box-sizing: border-box;
    width: 400px;
    height: 257px;
    border-radius: 5px;
    margin: auto;
    padding: 30px;
    font-size: 12px;
    font-weight: 600;
    z-index: 9999;
`;

const ModalTitle = styled.span`
    color: ${(props) => props.theme.color.dark};
    font-weight: 600;
    font-size: 20px;
`;

const ModalText = styled.p`
    color: ${(props) => props.theme.color.dark};
    font-size: 14px;
    font-weight: 400;
`

function OverDueYearEndFiling(props) {

    const [isDownloading, setIsDownloading] = useState(false);

    const [loadedPage, setLoadedPage] = useState(false);

    const handleClickFadeBackground = (e) => {
        if (props.handleClickNo) {
            props.handleClickNo();
        }
        e.stopPropagation();
        e.preventDefault();
    }

    const onClickDownload = async () => {
        setIsDownloading(true);

        const resp = (await request('database', 'downloadOverDueYearEndFiling'));
        if (resp.ok) {
            let fileName = `Overdue Year End Filing Report.xlsx`;
            var fileDownload = require('js-file-download');
            fileDownload(resp.data, fileName);
        } else {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsDownloading(false);
    }

    return (
        <FadeBackground onClick={handleClickFadeBackground}>
            <StyledOverDueYearEndFiling onClick={(e) => {e.stopPropagation(); e.preventDefault()}} {...props}>
                <ModalTitle>Overdue year end filing report</ModalTitle>
                <ModalText style={{marginTop: 30}}>This report lists all branches and sub-branches where prior year accounts filing has not been completed within three months of the end of the financial year.</ModalText>
                <div style={{display:'flex', marginTop:30}}>
                    <SecondaryButton caption='Cancel' onClick={() => props.handleClickNo ? props.handleClickNo() : {}} style={{width:126, height:35}}></SecondaryButton>
                    <PrimaryButton caption='Download to Excel' isLoading={isDownloading} onClick={() => onClickDownload()} style={{width:150, height:35, marginLeft:'auto'}}></PrimaryButton>
                </div>
            </StyledOverDueYearEndFiling>
        </FadeBackground>
    );
}

export default OverDueYearEndFiling;